import React from 'react'
import './pillarcard.css'
import Header from './header'
import Maincontent from './maincontent'
import Footer from './footer'

const Pillarcard = () => {
    const headerTitle = "Welcome to Pillarcard"

    return (
        <>
            <Header />
            <Maincontent title={headerTitle} />         
            <Footer />
        </>
    )
}

export default Pillarcard